















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InfoRow from './InfoRow.vue'

@Component({
	components: {
		InfoRow,
	},
})
export default class AddTask extends Vue {
	@Prop()
	private module!: any
}
